import { belongsTo, hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  desc: attr('string'),
  embed: attr('string'),
  isPublished: attr('boolean'),
  link: attr('string'),
  onPlatform: attr('boolean', {defaultValue: false}),
  title: attr('string'),
  verified: attr('boolean'),

  credits: hasMany('credit', { async: false }),
  review: belongsTo('project-review', { async: false }),
  image: belongsTo('image', { async: false }),
  company: belongsTo('company', { async: false }),
});
